<template>
  <sidebar @close="close">

  <template v-slot:head>
    <div class="field" align="center">
          <figure class="avatar">
            <img :src="qrImg" />
          </figure>
    </div>
    <h2 class="title is-4" align="center"> Avanpost Authenticator</h2>
    <hr>
  </template>

  <template v-slot:body>
      <div class="container has-text-centered">
        <div v-if="bindingStatusBool" class="select">
                  <select v-model="selectedBinding">
                    <option
                      v-for="(n, key) in bindings"
                      :key="key"
                      :value="n"
                    >  {{ $t('auth_factors.authenticator_binding') }} {{ n.Time }} </option>
                  </select>
        </div>

        <div v-if="bindingStatusBool && bindingList.length > 0">
                {{ $t('auth_factors.authenticator_device') }} {{ selectedBinding.DeviceName }}
        </div>

        <br>

        <div v-if="bindingStatusBool && bindingList.length > 0" class="button is-link is-fullwidth" @click="deactivate()">
            <span> {{ $t('auth_factors.authenticator_delete') }} </span>
        </div>

        <div v-else class="field" align="center">
          <div class="button is-link is-fullwidth" @click="newQR()">
            <span> {{ $t('auth_factors.authenticator_generate_new') }} </span>
          </div>
          <hr>
          <span> {{ $t('auth_factors.authenticator_scan') }} </span>
        </div>
      </div>
  </template>

  <template v-slot:foot>
      <div v-if="bindingStatusBool && additionalEnable" class="button is-link is-fullwidth" @click="additionalQR()">
        <span> {{ $t('auth_factors.authenticator_additional') }}  </span>
      </div>
      <br>
      <div v-if="additional && additionalEnable" class="field" align="center"> <span> {{ $t('auth_factors.authenticator_scan') }} </span> </div>
  </template>

  </sidebar>
</template>

<script>
import Sidebar from "@/components/Sidebar"
import axios from "axios";
export default {
  name: "MobileAuthenticatorDetails",
  components: {
    Sidebar
  },

  data() {
    return {
        qrImg: require("@/assets/mobile.png"), // Изображение QR-кода или дефолтная иконка
        error: "",
        bindingStatusBool: false, // Есть ли хотя бы одна привязка
        bindingPhone: null,
        bindings: {},        // Объект привязок для select (ключ — порядковый номер)
        bindingList: [],     // Массив привязок с сервера
        selectedBinding: {}, // Выбранная привязка в select
        additional: false,   // Флаг: показываем QR для доп. привязки
        additionalEnable: false, // Сервер разрешает доп. привязку
        pollingTimer: null,  // ID таймера поллинга
        previousBindingCount: 0 // Кол-во привязок до текущего опроса (для отслеживания новых)
    };
  },
  // Инициализация: загружаем текущие привязки, если нет — генерируем QR
  created() {
    this.fetchBinding().then(() => {
      if (!this.bindingStatusBool) {
        this.fetchQR()
      }
    })
    this.checkAdditionAvailable()
  },
  // Поллинг запускаем с задержкой, чтобы не мешать анимации открытия сайдбара
  mounted() {
    setTimeout(() => this.startPolling(), 1000)
  },
  methods: {
    // Загрузка QR-кода для первичной привязки
    fetchQR() {
      axios.get("/personal/api/v1/mobile-2fa/qr/image", {responseType: 'arraybuffer'}).then(
        r => {
          this.qrImg = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;
        },
        err => {
          console.log(err);
        }
      )
    },
    // Проверяем, разрешена ли доп. привязка на сервере
    checkAdditionAvailable() {
        axios.get('/personal/api/v1/mobile-2fa/qr/additional/check-available', {responseType: 'json'}).then(
          r => {
            if (r.data.Enable) {
              this.additionalEnable = true
            }
          }
        )
    },
    // Запрос текущих привязок. Возвращает промис для цепочки в created().
    // Если кол-во привязок увеличилось — значит новое устройство привязано:
    //   сбрасываем QR на дефолт, убираем флаг additional, останавливаем поллинг.
    // Если кол-во не изменилось — не трогаем QR (чтобы не сбить доп. привязку).
    fetchBinding() {
        return axios.get('/personal/api/v1/mobile-2fa/binding/current', {responseType: 'json'}).then(
          r => {
            this.bindings = {}
            if (r.data.length > 0) {
                const newCount = r.data.length
                this.bindingList = r.data
                for (let i = 0; i < r.data.length; i++) {
                  let dt = new Date(r.data[i].CreatedAt) ;
                  r.data[i].Time = dt.toLocaleString('en-US',  {dateStyle: 'medium',timeStyle: 'medium',hour12: false}) ;
                  this.bindings[(i+1)] = r.data[i]
                }
                this.selectedBinding = this.bindingList[0]
                this.bindingStatusBool = true
                if (newCount > this.previousBindingCount) {
                    this.qrImg = require("@/assets/mobile.png")
                    this.additional = false
                    this.stopPolling()
                }
                this.previousBindingCount = newCount
                this.$emit("update", true)
            }
          })
          .catch(() => {})
    },
    // Поллинг: каждые 1.5с проверяем привязки. stopPolling() в начале предотвращает дубли.
    startPolling() {
        this.stopPolling()
        this.pollingTimer = setInterval(() => {
            this.fetchBinding()
        }, 1500)
    },
    stopPolling() {
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer)
            this.pollingTimer = null
        }
    },
    // Удаление выбранной привязки
    deactivate() {
      const path = '/personal/api/v1/mobile-2fa/binding/' + this.selectedBinding.Id + '/deactivate'
      axios.post(path, {}, {responseType: 'text'}).then(
        r => {
          if (r.status == 200) {
            this.bindingStatusBool = false
            this.bindingPhone = null
            this.$emit("update", this.bindingStatusBool);
          }
          this.fetchBinding()
        }
      )
    },
    // Генерация QR для доп. устройства. После получения QR запускаем поллинг,
    // чтобы отследить момент привязки нового устройства (newCount > previousBindingCount).
    additionalQR() {
        axios.get('/personal/api/v1/mobile-2fa/qr/additional', {responseType: 'arraybuffer'}).then(
          r => {
            this.qrImg = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;
            this.additional = true
            this.startPolling()
          },
          err => {
            console.log(err);
          }
        )
    },
    // Генерация нового QR (когда привязок нет)
    newQR() {
        axios.get('/personal/api/v1/mobile-2fa/qr/new', {responseType: 'arraybuffer'}).then(
          r => {
            this.qrImg = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;

          },
          err => {
            console.log(err);
          }
        )
    },
    // Закрытие панели: останавливаем поллинг, уведомляем родителя о текущем статусе
    close() {
      this.error = "";
      this.stopPolling();
      this.$emit("update", this.bindingStatusBool);
      this.$emit("close");
    }
  }
};
</script>
